import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')`
  {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;